import {ApiResource} from 'common/util/model-resource/api-resource';
import {LookupTableDefinition} from 'apps/lexicon/src/models';

import {
  deleteLookupTableDefinitions,
  lookupTablesClient,
  updateLookupTableDefinition,
} from '../queries/app-api/lookup-tables-client';

// TODO - revisit null casting
export class LookupTablesResource extends ApiResource<LookupTableDefinition> {
  apiClient = lookupTablesClient;

  async patch(id: string, propsToUpdate: Partial<LookupTableDefinition>) {
    // optimistic update
    const copy = this.getOne(id).value;
    this.update({[id]: propsToUpdate});
    try {
      await updateLookupTableDefinition(id, propsToUpdate);
    } catch (error) {
      this.update({[id]: copy}, {partialUpdate: false});
      throw error;
    }
  }

  async delete(id: string) {
    // optimistic update
    const copy = this.getOne(id).value;

    super.delete(id);
    try {
      await deleteLookupTableDefinitions([id]);
    } catch (error) {
      super.update({[id]: copy}, {partialUpdate: false});
      throw error;
    }
  }

  async bulkDelete(ids: string[]) {
    // optimistic update
    const copy = this.getAll();
    ids.forEach((id) => {
      super.delete(id);
    });

    try {
      await deleteLookupTableDefinitions(ids);
    } catch (error) {
      // if status is not success, revert the update
      ids.forEach((id) => {
        copy?.get(id)?.value && this.update({[id]: copy.get(id)!.value!}, {partialUpdate: false});
      });

      throw error;
    }
  }
}
